import { AgentUpdatesPage } from "@/components/agent-updates/agent-updates-page";
import "./index.css";

export function App() {
  return <AgentUpdatesPage />;
}

export default App;
